import NotificationsRepository from './NotificationsRepository.js'

/**
 * @class
 * @implements NotificationsRepository
 */
export default class CookieNotificationsRepository extends NotificationsRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.cookie
   * @param {Function} deps.log
   * userProfileNotificationsValueObjectFactory
   */
  constructor({config, cookie, log, pendingPtaVOFactory, userProfileNotificationsValueObjectFactory}) {
    super()

    this._config = config
    this._cookie = cookie
    this._log = log
    this._pendingPtaVOFactory = pendingPtaVOFactory
    this._userProfileNotificationsValueObjectFactory = userProfileNotificationsValueObjectFactory
    this._SECURE_COOKIES = this._config.get('SECURE_COOKIES')
  }

  /**
   * @return {DO}
   */

  async getPortalAnnoucementsShowed() {
    const userProfileNotifications = this._cookie.getJSON('userProfileNotifications')

    const isPortalAnnoucementsShowed =
      userProfileNotifications && userProfileNotifications.hasOwnProperty('isPortalAnnoucementsShowed') // eslint-disable-line
        ? userProfileNotifications.isPortalAnnoucementsShowed
        : false

    return this._userProfileNotificationsValueObjectFactory({
      isPortalAnnoucementsShowed
    })
  }

  /**
   * @return {DO}
   */

  setPortalAnnoucementsShowed({isPortalAnnoucementsShowed = true} = {}) {
    this._cookie.set('userProfileNotifications', JSON.stringify({isPortalAnnoucementsShowed}), {
      secure: this._SECURE_COOKIES
    })
    return Promise.resolve()
  }

  /**
   * @return {Promise<Number>}
   */
  getPendingPta() {
    this._log('Getting pendings PTA')

    return new Promise((resolve, reject) => {
      try {
        const {PENDING_AD_KEY, PENDING_AD_ID_KEY} = this._config.get('notifications')
        const {getJSON: getCookie} = this._cookie
        const pendingAdData = getCookie(PENDING_AD_KEY)

        if (pendingAdData && pendingAdData[PENDING_AD_ID_KEY]) {
          resolve(this._pendingPtaVOFactory({pendingPta: 1}))
        } else {
          reject(new Error('CookieNotificationsRepository: No pending notifications found.'))
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  setPendingPta = ({adId}) =>
    new Promise(resolve => {
      const {PENDING_AD_KEY, PENDING_AD_ID_KEY} = this._config.get('notifications')
      const {set: setCookie} = this._cookie
      setCookie(PENDING_AD_KEY, {
        [PENDING_AD_ID_KEY]: adId
      })
      resolve()
    })
}
